import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/SignUp.css";
import {
  createUserWithEmailAndPassword,
  sendEmailVerification,
  signInWithPopup,
} from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { Timestamp } from "firebase/firestore";
import { auth, googleProvider } from "../firebase";
import { db } from "../firebase";
import VerificationModal from "./VerificationModal";

const SignUpPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [error, setError] = useState("");
  const [showVerificationModal, setShowVerificationModal] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      // 파이어베이스 회원가입
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        formData.email,
        formData.password
      );

      const user = userCredential.user;

      // 이메일 인증 메일 발송
      await sendEmailVerification(user);

      // users 컬렉션에 문서 생성
      await setDoc(doc(db, "users", user.uid), {
        email: user.email,
        createdAt: Timestamp.now(),
        subscription: null,
        purchaseHistory: [],
      });

      setShowVerificationModal(true); // 모달 표시
    } catch (error) {
      if (error.code === "auth/email-already-in-use") {
        setError("이미 사용 중인 이메일입니다.");
      } else {
        setError(`회원가입 중 오류가 발생했습니다: ${error.message}`);
      }
    }
  };

  const handleGoogleSignUp = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;

      // users 컬렉션에 문서 생성
      await setDoc(doc(db, "users", user.uid), {
        email: user.email,
        createdAt: Timestamp.now(),
        subscription: null,
        purchaseHistory: [],
      });

      navigate("/dashboard");
    } catch (error) {
      setError("구글 회원가입 중 오류가 발생했습니다.");
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleVerificationModalClose = () => {
    setShowVerificationModal(false);
    navigate("/login");
  };

  return (
    <div className="signup-page">
      <div className="logo" onClick={() => navigate("/")}>
        TOEICMON
      </div>
      <div className="signup-left">
        <img src="/images/signup-image.svg" alt="TOEIC Study" />
      </div>

      <div className="signup-right">
        <div className="signup-container">
          <h2
            style={{
              color: "#414042",
              fontSize: "32px",
              fontFamily: "Dela Gothic One",
              lineHeight: "42px",
            }}
          >
            Sign Up
          </h2>
          <form className="signup-form" onSubmit={handleSubmit}>
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              required
              style={{
                width: "400px",
                height: "50px",
                padding: "0 8px",
                border: "0",
                boxSizing: "border-box",
                backgroundColor: "#ffffff",
                color: "#424242",
                fontSize: "14px",
                fontFamily: "Montserrat",
                fontWeight: 500,
                lineHeight: "19px",
                outline: "none",
              }}
            />
            <input
              type="password"
              name="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleChange}
              required
              style={{
                width: "400px",
                height: "50px",
                padding: "0 8px",
                border: "0",
                boxSizing: "border-box",
                backgroundColor: "#ffffff",
                color: "#424242",
                fontSize: "14px",
                fontFamily: "Montserrat",
                fontWeight: 500,
                lineHeight: "19px",
                outline: "none",
              }}
            />
            {error && (
              <div className="error-container">
                {error}
                {error === "Email already exists." && (
                  <span
                    className="login-link"
                    onClick={() => navigate("/login")}
                  >
                    Go to Login
                  </span>
                )}
              </div>
            )}
            <button type="submit" className="submit-button">
              Sign Up
            </button>
            <button
              type="button"
              onClick={handleGoogleSignUp}
              className="google-signup-btn"
            >
              <img src="/images/google-icon.svg" alt="Google" />
              Google로 회원가입
            </button>
          </form>
          <p className="signin-link" style={{ color: "#414042" }}>
            이미 계정이 있으신가요?
            <a
              href="/login"
              style={{
                color: "#414042",
                textDecoration: "underline",
                marginLeft: "5px",
              }}
            >
              로그인
            </a>
          </p>
        </div>
      </div>

      {showVerificationModal && (
        <VerificationModal
          email={formData.email}
          onClose={handleVerificationModalClose}
        />
      )}
    </div>
  );
};

export default SignUpPage;
